"use client"

import { createContext, useContext, useReducer, ReactNode } from "react"
import type { TimesheetState, TimesheetAction } from "@/types/timesheet"

const initialState: TimesheetState = {
  timesheetItems: [],
  columns: [],
  visibleColumns: [],
  filters: {},
  selectedItems: [],
  currentPage: 1,
  pageSize: 20,
  totalCount: 0,
  hasNextPage: false,
  hasPreviousPage: false,
  loadingState: "idle" as any,
  error: null,
  savedViews: [],
  currentView: null,
  hasUnsavedChanges: false,
  currentUser: { id: "", name: "", count: 0 },
  stages: [],
  assignedUsers: [],
  isLoadingAssignedUsers: false,
  assignedUsersError: null,
  stageFilters: [],
  globalFilters: [],
  isFilterDrawerOpen: false,
  isBulkEditModalOpen: false,
  currentBulkEditField: null,
}

function timesheetReducer(state: TimesheetState, action: TimesheetAction): TimesheetState {
  switch (action.type) {
    case "SET_LOADING_STATE":
      return { ...state, loadingState: action.payload }
    case "SET_ERROR":
      return { ...state, error: action.payload }
    case "SET_TIMESHEETS":
      return {
        ...state,
        timesheetItems: action.payload.data,
        totalCount: action.payload.totalCount,
        hasNextPage: action.payload.hasNextPage,
        hasPreviousPage: action.payload.hasPreviousPage,
        facets: action.payload.facets,
      }
    default:
      return state
  }
}

const NotificationContext = createContext<{
  state: TimesheetState
  dispatch: React.Dispatch<TimesheetAction>
} | null>(null)

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(timesheetReducer, initialState)

  return (
    <NotificationContext.Provider value={{ state, dispatch }}>
      {children}
    </NotificationContext.Provider>
  )
}

export function useNotificationCenter() {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error("useTimesheet must be used within a NotificationProvider")
  }
  return context
} 